import { useIntl } from 'react-intl'

import { type SupportBlocking as SupportBlockingValue } from '@onr/schema'
import { BanIcon, ClockIcon } from 'lucide-react'

import { cn } from '@/lib/utils.ts'

export interface SupportBlockingProps {
  readonly blocking: SupportBlockingValue
  readonly className?: string
}

export const SupportBlocking = ({ blocking, className }: SupportBlockingProps) => {
  const intl = useIntl()
  if (blocking === 'canContinue') {
    return null
  }
  const Icon = blocking === 'blocked' ? BanIcon : ClockIcon
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-sm font-bold',
        blocking === 'blocked' ? 'text-red-700' : 'text-orange-800',
        className
      )}>
      <Icon aria-hidden className="size-3 stroke-[2.5]" />
      {intl.formatMessage({ id: `soutien.blocking.short.${blocking}` })}
    </span>
  )
}
